import axios from "axios";
import { toast } from "react-toastify";
import {
  LIST_OF_STUDENT_CONTRACT,
  LIST_OF_STUDENT_CONTRACT_ERROR,
  SINGLEL_STUDENT_CONTRACT,
  SINGLEL_STUDENT_CONTRACT_ERROR
} from "../ActionTypes";
import {
  STUDENT_CONTRACT_LIST_API,
  ADD_STUDENT_CONTRACT_API,
  UPDATE_STUDENT_CONTRACT_API,
  SINGLE_STUDENT_CONTRACT_LIST_API,
  PAGE,
  LIMIT,
} from "../constants";

const token = sessionStorage.getItem("token");
const header = {
  headers: {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "POST,GET,OPTIONS,PUT,DELETE,PATCH",
    "Access-Control-Allow-Headers": "Content-Type, X-Auth-Token, Origin, Authorization"
  },
};

export const StudentContractList = (
  page = PAGE,
  limit = LIMIT,
  token: string,
  order: string,
  search: any,
) => {
  header.headers.Authorization = `Bearer ${token}`;
  return async (dispatch: any) => {
    return await axios
      .get(`${STUDENT_CONTRACT_LIST_API}?page=${page}&limit=${limit}&orderBy=${order}&search=${search}`, header,)
      .then((res) => {
        dispatch({
          type: LIST_OF_STUDENT_CONTRACT,
          payload: res.data,
        });
        return res;
      })
      .catch((error) => {
        dispatch({
          type: LIST_OF_STUDENT_CONTRACT_ERROR,
        });
        toast.error(error.response.data.errorMsg);
      });
  };
};

export const addStudentContaract = async (userObj: any, token: string) => {
  header.headers.Authorization = `Bearer ${token}`;
  return await axios
    .post(ADD_STUDENT_CONTRACT_API, userObj, header)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response;
    });
};

export const updateStudentContaract = async (id: any, userObj: any, token: string) => {
  header.headers.Authorization = `Bearer ${token}`;
  return await axios
    .put(`${UPDATE_STUDENT_CONTRACT_API}/${id}`, userObj, header)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response;
    });
};

export const SingleStudentContaract = async (id: string | number, token: string) => {
  header.headers.Authorization = `Bearer ${token}`;
  return await axios
    .get(`${SINGLE_STUDENT_CONTRACT_LIST_API}/${id}`, header)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      toast.error(error.response.data.errorMsg);
      return error.response;
    });
};
